<template>
  <div>
    <div class="md-layout">

      <div class="md-layout-item">
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item my-title">
            爆款产品
          </div>
          <div class="md-layout-item">
            <md-button class="md-icon-button md-raised md-primary" @click="showAddProduct('fashion_product')"
                       :disabled="staticStatistics.product_data.fashion_products.length>=6">
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </div>
        <draggable v-model="staticStatistics.product_data.fashion_products" draggable=".item">
          <div v-for="element in staticStatistics.product_data.fashion_products" :key="element.name" class="item">
            <div class="md-layout md-alignment-center">
              <div class="md-layout-item">
                <img :src="element.cover" width="100px" height="60px">
                <p>{{ element.name }}</p>
              </div>
              <div class="md-layout-item">
                <md-button class="md-icon-button md-raised md-accent md-dense" @click="removeFashionItem(element)">
                  <md-icon>clear</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </draggable>
      </div>

      <div class="md-layout-item">
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item my-title">
            新品推荐
          </div>
          <div class="md-layout-item">
            <md-button class="md-icon-button md-raised md-primary" @click="showAddProduct('new_product')"
                       :disabled="staticStatistics.product_data.new_products.length>=6">
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </div>
        <draggable v-model="staticStatistics.product_data.new_products" draggable=".item">
          <div v-for="element in staticStatistics.product_data.new_products" :key="element.name" class="item">
            <div class="md-layout md-alignment-center">
              <div class="md-layout-item">
                <img :src="element.cover" width="100px" height="60px">
                <p>{{ element.name }}</p>
              </div>
              <div class="md-layout-item">
                <md-button class="md-icon-button md-raised md-accent md-dense" @click="removeNewItem(element)">
                  <md-icon>clear</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </draggable>
      </div>

      <div class="md-layout-item">
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item my-title">
            语音搜索热词
          </div>
        </div>
        <md-chips v-model="staticStatistics.voice_data.hot_voice_words" md-limit='20'
                  md-placeholder="添加一个..."></md-chips>
      </div>
    </div>

    <div class="md-layout md-alignment-center-right">
      <md-button class="md-fab" @click="setStatic">
        <md-icon>save</md-icon>
      </md-button>
    </div>

    <md-dialog :md-active.sync="showAddProductDialog">
      <md-dialog-title>{{ toAddProductType === 'fashion_product' ? '添加爆款产品' : '添加新品' }}</md-dialog-title>
      <div class="dialog_content">
        <md-field>
          <label>产品名称</label>
          <md-input v-model="newProduct.name"></md-input>
        </md-field>
        <md-field>
          <label>产品图片地址</label>
          <md-input v-model="newProduct.cover"></md-input>
        </md-field>
      </div>
      <md-dialog-actions>
        <md-button class="md-accent" @click="showAddProductDialog = false">取消</md-button>
        <md-button class="md-primary" @click="addProduct">添加</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>

  </div>
</template>

<script>

import draggable from 'vuedraggable'

export default {
  name: "StaticStatisticsSetting",
  components: {
    draggable,
  },
  data: () => ({
    newProduct: {
      name: null, cover: null,
    },
    staticStatistics: {
      voice_data: {
        nav_destination_tendencies: [],
        voice_categories: [],
        hot_voice_words: [],
      },
      song_data: {
        top_songs: [],
        top_singers: [],
      },
      product_data: {
        fashion_products: [],
        new_products: [],
      }
    },
    showAddProductDialog: false,
    toAddProductType: null,
    toast: false,
    toastMsg: "",
  }),
  mounted() {
    this.loadStatic();
  },
  methods: {
    loadStatic: function () {
      this.$http.get('/api/statistics/static/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.staticStatistics = data.data;
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    setStatic: function () {
      this.$http.post('/api/statistics/static/', this.staticStatistics).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('修改成功');
                this.loadStatic();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    removeFashionItem: function (item) {
      const index = this.staticStatistics.product_data.fashion_products.indexOf(item);
      if (index > -1) {
        this.staticStatistics.product_data.fashion_products.splice(index, 1);
      }
    },
    removeNewItem: function (item) {
      const index = this.staticStatistics.product_data.new_products.indexOf(item);
      if (index > -1) {
        this.staticStatistics.product_data.new_products.splice(index, 1);
      }
    },
    showAddProduct: function (type) {
      this.showAddProductDialog = true;
      this.toAddProductType = type;
    },
    addProduct: function () {
      if (!this.newProduct.cover) {
        this.showErrorTips("必须输入图片地址");
        return;
      }
      if (this.toAddProductType === 'fashion_product') {
        this.staticStatistics.product_data.fashion_products.push({
          name: this.newProduct.name,
          cover: this.newProduct.cover,
        });
      } else {
        this.staticStatistics.product_data.new_products.push({
          name: this.newProduct.name,
          cover: this.newProduct.cover,
        });
      }
      this.newProduct = {};
      this.showAddProductDialog = false;
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  },

}
</script>

<style scoped>
.item {
  margin: 4px 10px 4px 10px;
  padding: 8px 0 4px 0;
  background-color: #8d99cd;
  border-radius: 4px;
}

p {
  color: white;
  margin: 0;
}

.my-title {
  font-size: 18px;
  text-align: left;
}

.dialog_content {
  padding: 0 10px 0 10px;
}
</style>